/** Consumi & Energia screen */
import React from 'react';
import { Zap, Droplets, Flame, TrendingUp, AlertTriangle, ArrowUpRight,
  Building2, Sparkles } from 'lucide-react';
import { C, fontHead, overline, primaryBtn } from '../_tokens';

export default function ScreenConsumi() {
  return (
    <div style={{ padding: '32px 36px', background: C.bg, color: C.text, fontFamily: 'Inter', minHeight: '100%' }}>
      {/* HEADER */}
      <div style={{ display: 'flex', alignItems: 'flex-end', justifyContent: 'space-between', marginBottom: 26 }}>
        <div>
          <div style={{ ...overline, marginBottom: 6 }}>Energy & Sustainability</div>
          <h1 style={{ fontFamily: fontHead, fontSize: 38, fontWeight: 600, margin: 0,
                       letterSpacing: '-0.025em', lineHeight: 1 }}>
            Consumi & Efficienza
          </h1>
        </div>
        <div style={{ display: 'flex', gap: 10 }}>
          <button style={{
            background: C.surf, color: C.text, border: `1px solid ${C.border}`,
            padding: '10px 14px', borderRadius: 10, fontSize: 13, cursor: 'pointer',
            display: 'inline-flex', alignItems: 'center', gap: 6,
          }}>
            <Building2 size={13} /> Hotel Galleria
          </button>
          <button style={{ ...primaryBtn }}>+ Importa rilevazione</button>
        </div>
      </div>

      {/* AI BANNER */}
      <div style={{
        padding: '18px 24px', borderRadius: 18,
        background: `linear-gradient(135deg, ${C.terra}11, transparent 70%), ${C.surf}`,
        border: `1px solid ${C.terra}55`,
        marginBottom: 24, display: 'flex', alignItems: 'center', gap: 16,
      }}>
        <div style={{
          width: 42, height: 42, borderRadius: 12, background: `${C.terra}22`,
          border: `1px solid ${C.terra}55`, display: 'grid', placeItems: 'center', flexShrink: 0,
        }}><AlertTriangle size={20} color={C.terra} /></div>
        <div style={{ flex: 1 }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 3 }}>
            <span style={{ fontSize: 10.5, letterSpacing: '0.15em', textTransform: 'uppercase',
                           color: C.terra, fontWeight: 600 }}>Alert sistema · 11 Giugno 09:40</span>
          </div>
          <div style={{ fontSize: 14.5, fontWeight: 500 }}>
            Consumi acqua a <b style={{ color: C.terra }}>+28% vs media trimestrale</b>.
            Possibile perdita nascosta nel piano 4 (rilevazione contatore di zona).
          </div>
        </div>
        <button style={{
          ...primaryBtn, background: `linear-gradient(135deg, ${C.terra}, #C95A40)`,
          fontSize: 12,
        }}>Indaga ora <ArrowUpRight size={12} /></button>
      </div>

      {/* KPI ROW */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: 16, marginBottom: 24 }}>
        <BigKpi icon={Zap} label="Energia" value="142.380" unit="kWh" sub="+3.2% vs maggio" accent={C.gold} />
        <BigKpi icon={Droplets} label="Acqua" value="2.847" unit="m³" sub="+28% · ALERT" accent={C.terra} alert />
        <BigKpi icon={Flame} label="Gas" value="—" unit="Smc" sub="All-electric" accent={C.cyan} />
        <BigKpi icon={TrendingUp} label="Indice Eff." value="78.4" unit="/100" sub="+2.3 vs Apr" accent={C.emerald} />
      </div>

      {/* CHART + RANKING */}
      <div style={{ display: 'grid', gridTemplateColumns: '1.6fr 1fr', gap: 16, marginBottom: 24 }}>
        <div style={{ background: C.surf, borderRadius: 20, padding: 26, border: `1px solid ${C.border}` }}>
          <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 22 }}>
            <div>
              <div style={{ fontFamily: fontHead, fontSize: 20, fontWeight: 600, letterSpacing: '-0.01em' }}>
                Trend Indice Efficienza
              </div>
              <div style={{ fontSize: 11.5, color: C.textSec, marginTop: 3 }}>
                Hotel Galleria · finestra mobile 12 mesi · ROI degli interventi energetici
              </div>
            </div>
            <div style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
              <div style={{ textAlign: 'right' }}>
                <div style={{ ...overline }}>Delta da Lug 25</div>
                <div style={{ fontFamily: fontHead, fontSize: 22, fontWeight: 600, color: C.emerald }}>+5.7</div>
              </div>
              <div style={{ height: 38, width: 1, background: C.border }} />
              <div style={{ textAlign: 'right' }}>
                <div style={{ ...overline }}>Ultimo</div>
                <div style={{ fontFamily: fontHead, fontSize: 22, fontWeight: 600, color: C.gold }}>78.4</div>
              </div>
            </div>
          </div>
          <BigChart />
          <div style={{ marginTop: 14, padding: '10px 14px', background: 'rgba(255,255,255,0.03)',
                        borderRadius: 10, fontSize: 11.5, color: C.textSec, lineHeight: 1.5 }}>
            Trend basato sulla media mobile a 12 mesi · finestra rolling aggiornata ad ogni nuova rilevazione mensile.
          </div>
        </div>
        <div style={{ background: C.surf, borderRadius: 20, padding: 22, border: `1px solid ${C.border}` }}>
          <div style={{ marginBottom: 18 }}>
            <div style={{ fontFamily: fontHead, fontSize: 18, fontWeight: 600, letterSpacing: '-0.01em' }}>Ranking gruppo</div>
            <div style={{ fontSize: 11.5, color: C.textSec, marginTop: 2 }}>Posizione Galleria nei 6 hotel</div>
          </div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: 7 }}>
            {[
              { n: 'Scarlatti', eff: 87.2, top: true },
              { n: 'Arcimboldi', eff: 84.1, ae: true },
              { n: 'Galleria', eff: 81.5, me: true },
              { n: 'Heart', eff: 77.3 },
              { n: 'Kira', eff: 76.8, ae: true },
              { n: 'Vivaldi', eff: 71.6 },
            ].map((h, i) => (
              <div key={h.n} style={{
                display: 'flex', alignItems: 'center', gap: 12,
                padding: '9px 12px', borderRadius: 9,
                background: h.me ? `${C.gold}11` : 'rgba(255,255,255,0.02)',
                border: `1px solid ${h.me ? C.gold + '44' : C.border}`,
              }}>
                <span style={{ fontFamily: fontHead, fontSize: 12, color: h.me ? C.gold : C.textSec,
                               fontWeight: 600, minWidth: 22 }}>#{i + 1}</span>
                <span style={{ flex: 1, fontSize: 12.5, fontWeight: h.me ? 600 : 500, color: h.me ? C.gold : C.text }}>
                  {h.n} {h.me && <span style={{ fontSize: 10, color: C.textSec, fontWeight: 400 }}>(tu)</span>}
                </span>
                {h.ae && <Zap size={10} color={C.gold} />}
                <span style={{ fontFamily: fontHead, fontWeight: 600, fontSize: 13, color: h.me ? C.gold : C.text }}>{h.eff}</span>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* UTILITIES TRENDS */}
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: 16 }}>
        <UtilityCard icon={Zap} label="Energia per camera occupata" value="25.4" unit="kWh/cam" trend={[28, 26, 27, 25, 26, 25.4]} accent={C.gold} />
        <UtilityCard icon={Droplets} label="Acqua per camera occupata" value="0.34" unit="m³/cam" trend={[0.26, 0.28, 0.27, 0.31, 0.33, 0.34]} accent={C.terra} alert />
        <UtilityCard icon={Flame} label="Gas (all-electric)" value="N/A" unit="" trend={[]} accent={C.cyan} disabled />
      </div>
    </div>
  );
}

const BigKpi = ({ icon: Icon, label, value, unit, sub, accent, alert }) => (
  <div style={{
    background: C.surf, borderRadius: 18, padding: 22,
    border: `1px solid ${alert ? accent + '55' : C.border}`,
    position: 'relative', overflow: 'hidden',
  }}>
    {alert && <div style={{
      position: 'absolute', top: 0, right: 0, width: 150, height: 150,
      background: `radial-gradient(circle at top right, ${accent}22, transparent 60%)`,
      pointerEvents: 'none',
    }} />}
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
      <div style={{
        width: 36, height: 36, borderRadius: 9, background: `${accent}1a`,
        display: 'grid', placeItems: 'center',
      }}><Icon size={16} color={accent} /></div>
      {alert && <span style={{ width: 8, height: 8, borderRadius: '50%', background: accent,
                               boxShadow: `0 0 12px ${accent}` }} />}
    </div>
    <div style={{ ...overline, marginBottom: 6, color: accent, opacity: 0.9 }}>{label}</div>
    <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
      <span style={{ fontFamily: fontHead, fontSize: 40, fontWeight: 600,
                     letterSpacing: '-0.04em', lineHeight: 1, color: accent }}>{value}</span>
      <span style={{ fontSize: 13, color: C.textSec }}>{unit}</span>
    </div>
    <div style={{ fontSize: 11.5, color: alert ? accent : C.textSec, marginTop: 8, fontWeight: alert ? 600 : 400 }}>{sub}</div>
  </div>
);

const UtilityCard = ({ icon: Icon, label, value, unit, trend, accent, alert, disabled }) => {
  const max = Math.max(...trend, 1);
  const W = 250, H = 60;
  const pts = trend.length > 0 ? trend.map((v, i) => `${(i / (trend.length - 1)) * W},${H - (v / max) * H * 0.85}`).join(' ') : '';
  return (
    <div style={{
      background: C.surf, borderRadius: 18, padding: 22,
      border: `1px solid ${alert ? accent + '55' : C.border}`,
      opacity: disabled ? 0.6 : 1,
    }}>
      <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 14 }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
          <Icon size={15} color={accent} />
          <span style={{ ...overline, color: accent }}>{label}</span>
        </div>
        {alert && <span style={{
          fontSize: 9.5, padding: '2px 7px', borderRadius: 4, fontWeight: 700,
          background: `${accent}22`, color: accent, letterSpacing: '0.05em',
        }}>+28%</span>}
      </div>
      <div style={{ display: 'flex', alignItems: 'baseline', gap: 6 }}>
        <span style={{ fontFamily: fontHead, fontSize: 32, fontWeight: 600,
                       letterSpacing: '-0.04em', color: disabled ? C.textDim : C.text }}>{value}</span>
        <span style={{ fontSize: 12, color: C.textSec }}>{unit}</span>
      </div>
      {trend.length > 0 && (
        <svg viewBox={`0 0 ${W} ${H}`} width="100%" height={H} style={{ marginTop: 10 }}>
          <polyline points={pts} fill="none" stroke={accent} strokeWidth="1.5" />
          {trend.map((v, i) => (
            <circle key={i} cx={(i / (trend.length - 1)) * W}
                    cy={H - (v / max) * H * 0.85} r="2" fill={accent} />
          ))}
        </svg>
      )}
    </div>
  );
};

const BigChart = () => {
  const data = [72, 73, 71, 74, 75, 73, 76, 75, 77, 76, 78, 78.4];
  const W = 600, H = 220, PAD = 30;
  const max = 85, min = 65;
  const labels = ['Lug', 'Ago', 'Set', 'Ott', 'Nov', 'Dic', 'Gen', 'Feb', 'Mar', 'Apr', 'Mag', 'Giu'];
  const markers = {};
  const pts = data.map((v, i) => [PAD + (i / (data.length - 1)) * (W - 2 * PAD),
                                   PAD + (1 - (v - min) / (max - min)) * (H - 2 * PAD)]);
  const path = pts.map((p, i) => (i === 0 ? `M${p[0]},${p[1]}` : `L${p[0]},${p[1]}`)).join(' ');
  const area = path + ` L${pts[pts.length - 1][0]},${H - PAD} L${pts[0][0]},${H - PAD} Z`;
  return (
    <svg viewBox={`0 0 ${W} ${H}`} style={{ width: '100%', height: H }}>
      <defs>
        <linearGradient id="gradC" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={C.gold} stopOpacity="0.45" />
          <stop offset="100%" stopColor={C.gold} stopOpacity="0" />
        </linearGradient>
      </defs>
      {[0, 1, 2, 3, 4].map(i => (
        <line key={i} x1={PAD} x2={W - PAD} y1={PAD + i * (H - 2 * PAD) / 4} y2={PAD + i * (H - 2 * PAD) / 4}
              stroke={C.border} strokeDasharray="2 3" />
      ))}
      <path d={area} fill="url(#gradC)" />
      <path d={path} stroke={C.gold} strokeWidth="2.2" fill="none" />
      {pts.map((p, i) => (
        <g key={i}>
          {markers[i] && (
            <g>
              <line x1={p[0]} x2={p[0]} y1={PAD} y2={H - PAD} stroke={C.gold} strokeWidth="1" strokeDasharray="3 3" opacity="0.5" />
              <rect x={p[0] - 28} y={PAD - 6} width="56" height="18" rx="4" fill={C.gold} />
              <text x={p[0]} y={PAD + 6} fill={C.bg} fontSize="10" textAnchor="middle" fontWeight="600">{markers[i]}</text>
            </g>
          )}
          <circle cx={p[0]} cy={p[1]} r={i === pts.length - 1 ? 5 : 3}
                  fill={i === pts.length - 1 ? C.gold : C.surf}
                  stroke={C.gold} strokeWidth="1.5" />
        </g>
      ))}
      {labels.map((l, i) => {
        const x = PAD + (i / (labels.length - 1)) * (W - 2 * PAD);
        return <text key={l} x={x} y={H - 8} fill={C.textSec} fontSize="10" textAnchor="middle">{l}</text>;
      })}
    </svg>
  );
};
